<template>
  <div>
    <Modal
      title="查看视频资源"
      v-model="dialog"
      :mask-closable="false"
      width="1200"
      @on-visible-change="changeVisible"
      class="resourceDetail-modal"
    >
      <div class="flexform">
        <div class="flexform-item100">
          <label class="labelw">行政区划：</label>
          <div class="itemdiv">
            {{ detail.province || "暂无" }}- {{ detail.city || "暂无" }}-
            {{ detail.area || "暂无" }}-
            {{ detail.jd || "暂无" }}
          </div>
        </div>
        <div class="flexform-item100">
          <label class="labelw">行业：</label>
          <div class="itemdiv">{{ detail.hy || "暂无" }}</div>
        </div>
      </div>
      <div class="flexsb mt-24">
        <div class="w240px">
          <Input
            placeholder="请输入资源名称"
            v-model.trim="name"
            @on-enter="searchSearch"
            @on-blur="searchSearch"
          ></Input>
        </div>
        <p>
          <span>当前数量：{{ pageTotal }}</span>
        </p>
      </div>
      <Table class="mt-24" stripe :columns="dataCol" :data="dataList">
        <template slot-scope="{ row, index }" slot="action">
          <img
            v-if="row.img"
            style="width: 30px; height: 30px"
            @click="imgClick(row.img)"
            :src="row.img"
          />
          <span v-else>-/-</span>
        </template>
      </Table>
      <Row class="mt-16" type="flex" justify="center">
        <Page
          :total="pageTotal"
          :page-size="search.pageSize"
          :page-size-opts="psize"
          :current="search.pageIndex"
          @on-change="handlePage"
          @on-page-size-change="sizeChange"
          show-sizer
          show-total
          show-elevator
          placement="top"
          class-name="page"
        />
      </Row>
      <div slot="footer" class="resourceDetail-modal-footer">
        <Button shape="circle" class="w104px" @click="cancle">返回</Button>
      </div>
    </Modal>
    <Modal title="通道快照" v-model="imgDialog" :mask-closable="false" width="700">
      <img class="w100" :src="imgUrl" alt />
    </Modal>
  </div>
</template>
<script>
const dataCol = [
  {
    title: "视频资源名称",
    key: "name",
    tooltip: true
  },
  {
    title: "视频资源ID",
    key: "channelId",
    tooltip: true
  },
  {
    title: "所属省",
    key: "provinceName",
    tooltip: true
  },
  {
    title: "所属市",
    key: "cityName",
    tooltip: true
  },
  {
    title: "所属区/县",
    key: "areaName",
    tooltip: true
  },
  {
    title: "所属乡镇/街道",
    key: "jdName",
    tooltip: true,
    render: (h, params) => {
      return h("span", params.row.jdName || "-/-");
    }
  },
  {
    title: "所属行业",
    key: "hyName",
    tooltip: true
  },
  {
    title: "通道快照",
    slot: "action"
  }
];
import { getVideoList } from "@/api/resource";

export default {
  name: "",
  props: {
    detail: {
      type: Object,
      default: () => {
        return {
          address: "山东省济南市历下区舜华路街道",
          industry: "社会治安"
        };
      }
    }
  },
  data() {
    return {
      dialog: false,
      dataCol: dataCol,
      dataList: [],
      pageTotal: 0,
      psize: [5, 10],
      search: {
        pageSize: 5,
        pageIndex: 1
      },
      imgDialog: false,
      imgUrl: "",
      name: ""
    };
  },
  watch: {
    //解决当前页最后一条删除后，没有自动折页的问题
    pageTotal() {
      const cPage = this.pageTotal / this.search.pageSize;
      if (this.search.pageIndex === cPage + 1 && this.search.pageIndex != 1) {
        this.search.pageIndex = this.search.pageIndex - 1;
        this.getList(); //获取列表数据
      }
    }
  },
  created() {
    this.dialog = true;
    console.log("detail=======", this.detail);
    this.getList();
  },
  methods: {
    imgClick(url) {
      this.imgDialog = true;
      this.imgUrl = url;
    },
    getList() {
      console.log("name", this.name);
      let data = {
        channelIdStr:
          this.detail.catalogue.channelIds &&
          this.detail.catalogue.channelIds.length
            ? this.detail.catalogue.channelIds.join(",")
            : undefined,
        name: this.name ? this.name : undefined,
        province: this.detail.catalogue.province
          ? this.detail.catalogue.province == "root"
            ? undefined
            : this.detail.catalogue.province
          : undefined,
        city: this.detail.catalogue.city
          ? this.detail.catalogue.city
          : undefined,
        area: this.detail.catalogue.area
          ? this.detail.catalogue.area
          : undefined,
        jd: this.detail.catalogue.jd ? this.detail.catalogue.jd : undefined,
        hy:
          this.detail.catalogue.hy != "-1"
            ? this.detail.catalogue.hy
            : undefined,
        pageIndex: this.search.pageIndex,
        pageSize: this.search.pageSize
      };
      console.log(data, "资源查询对象");
      getVideoList(data).then(res => {
        console.log(res, "资源列表");
        let json = res.data.data;
        this.dataList = json;
        this.pageTotal = res.data.page.totalCount;
      });
    },
    searchSearch() {
      this.search.pageIndex = 1;
      this.search.pageSize = 5;
      this.getList();
    },
    handlePage(value) {
      this.search.pageIndex = value;
      this.getList();
    },
    sizeChange(value) {
      this.search.pageSize = value;
      this.getList();
    },
    cancle() {
      this.$emit("update:dialog", false);
    },
    changeVisible(val) {
      if (!val) {
        this.$emit("update:dialog", false);
      }
    }
  }
};
</script>
<style lang="scss">
.resourceDetail {
  &-modal {
    &-footer {
      text-align: right;
    }
    .ivu-modal-footer {
      border-top: unset;
    }
  }
}
</style>